export default __webpack_public_path__ + "locales/nl/HotkeysPanel.json?hash=49c8cfe38f7a07145d9c9ef60b61a640";